import { randomStr } from '../utils/String';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      default: () => randomStr(),
    },
    options: {
      type: Array,
      default: () => [],
      validator(v) {
        return v.every(option => ['string', 'object'].includes(typeof option));
      },
    },
    value: {
      type: [String, Array, Number],
      default: undefined,
      validator(v) {
        const isValid = value => ['string', 'number'].includes(typeof value);

        return isValid(v) || v.every(isValid);
      },
    },
    multiple: { type: Boolean },
    disabled: { type: Boolean },
  },
};
